export const Section = {
  benefits: 'benefits',
  kindsGas: 'kindsGas',
  certificates: 'certificates',
  findUs: 'findUs',
  bonuses: 'bonuses',
  questions: 'questions',
  contacts:'contacts',
}
